var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.75C8.85 21.75 4.25 17.15 4.25 11.5C4.25 5.85 8.85 1.25 14.5 1.25C20.15 1.25 24.75 5.85 24.75 11.5C24.75 17.15 20.15 21.75 14.5 21.75ZM14.5 2.75C9.67 2.75 5.75 6.68 5.75 11.5C5.75 16.32 9.67 20.25 14.5 20.25C19.33 20.25 23.25 16.32 23.25 11.5C23.25 6.68 19.33 2.75 14.5 2.75Z",
    fill: "#60656C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0004 22.75C24.8104 22.75 24.6204 22.68 24.4704 22.53L22.4704 20.53C22.1804 20.24 22.1804 19.76 22.4704 19.47C22.7604 19.18 23.2404 19.18 23.5304 19.47L25.5304 21.47C25.8204 21.76 25.8204 22.24 25.5304 22.53C25.3804 22.68 25.1904 22.75 25.0004 22.75Z",
    fill: "#60656C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2994c3e470964b1866caa37a2b694522.svg";
export { ForwardRef as ReactComponent };